/* BRUMA — En-tête : transparence au scroll + burger mobile */
(function () {
  "use strict";
  function init() {
    var head = document.getElementById("brumaHead");
    if (!head) return;
    var transparent = head.getAttribute("data-transparent") === "true";
    var threshold = 40;
    function onScroll() {
      if (!transparent) return;
      if (window.scrollY > threshold) head.classList.add("is-stuck");
      else head.classList.remove("is-stuck");
    }
    if (transparent) {
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    } else {
      head.classList.add("is-stuck");
    }
    var burger = document.getElementById("brumaBurger");
    if (burger) {
      burger.addEventListener("click", function () {
        head.classList.toggle("is-open");
      });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
